import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const BDataTable = require(process.env.MIX_APP_ROOT + '/bgo/bgo-components/resources/js/store/BDataTable').default;
const Websockets = require(process.env.MIX_APP_ROOT + '/bgo/websockets/resources/js/store/Websockets').default;
const Translations = require(process.env.MIX_APP_ROOT + '/bgo/translations/resources/js/store/Translations').default;
const Themes = require(process.env.MIX_APP_ROOT + '/bgo/theme-changer/resources/js/store/themeChanger').default;
const User = require(process.env.MIX_APP_ROOT + '/bgo/users/resources/js/store/user').default;
const Notifications = require(process.env.MIX_APP_ROOT +
    '/modules/notifications/resources/js/store/notifications').default;
const Reports = require(process.env.MIX_APP_ROOT + '/modules/reports/resources/js/store/reports').default;
const Trackers = require(process.env.MIX_APP_ROOT + '/modules/reports/resources/js/store/trackers').default;
const Consultants = require(process.env.MIX_APP_ROOT + '/modules/consultants/resources/js/store/Consultants').default;
const NotificationConsultant = require(process.env.MIX_APP_ROOT +
    '/modules/consultants/resources/js/store/NotificationConsultant').default;
const Patients = require(process.env.MIX_APP_ROOT + '/modules/patients/resources/js/store/Patients').default;
const NotificationPatient = require(process.env.MIX_APP_ROOT +
    '/modules/patients/resources/js/store/NotificationPatient').default;
const AdverseEvent = require(process.env.MIX_APP_ROOT + '/modules/patients/resources/js/store/AdverseEvent').default;
const Memo = require(process.env.MIX_APP_ROOT + '/modules/patients/resources/js/store/Memo').default;
const PharmacyGroups = require(process.env.MIX_APP_ROOT +
    '/modules/pharmacy-groups/resources/js/store/PharmacyGroups').default;
const NotificationPharmacyGroup = require(process.env.MIX_APP_ROOT +
    '/modules/pharmacy-groups/resources/js/store/NotificationPharmacyGroup').default;
const PharmacySites = require(process.env.MIX_APP_ROOT +
    '/modules/pharmacy-sites/resources/js/store/PharmacySites').default;
const NotificationPharmacySite = require(process.env.MIX_APP_ROOT +
    '/modules/pharmacy-sites/resources/js/store/NotificationPharmacySite').default;
const DmsUsers = require(process.env.MIX_APP_ROOT + '/modules/users/resources/js/store/DmsUsers').default;
const Laboratories = require(process.env.MIX_APP_ROOT +
    '/modules/blood-result-providers/resources/js/store/Laboratories.js').default;
const NotificationLaboratory = require(process.env.MIX_APP_ROOT +
    '/modules/blood-result-providers/resources/js/store/NotificationLaboratory.js').default;
const ASTMDevices = require(process.env.MIX_APP_ROOT +
    '/modules/astm-devices/resources/js/store/ASTMDevices.js').default;

const QuickHelp = require(process.env.MIX_APP_ROOT + '/bgo/users/resources/js/store/quickHelp').default;

const DmsRoles = require(process.env.MIX_APP_ROOT + '/bgo/users/resources/js/store/DmsRoles').default;

const QualityControl = require(process.env.MIX_APP_ROOT +
    '/modules/quality-control/resources/js/store/QualityControl').default;

const UploadPdf = require(process.env.MIX_APP_ROOT + '/modules/patients/resources/js/store/UploadPdf').default;
const spire = require(process.env.MIX_APP_ROOT + '/modules/spire-ftp/resources/js/store/spireFtp').default;
const Search = require(process.env.MIX_APP_ROOT + '/modules/global-search/resources/js/store/Search').default;
const SecureSignForms = require(process.env.MIX_APP_ROOT +
    '/modules/dashboard/resources/js/store/SecureSignForms').default;
const Acl = require(process.env.MIX_APP_ROOT + '/bgo/acl/resources/js/store/Acl').default;

const store = new Vuex.Store({
    modules: {
        acl: Acl,
        trackers: Trackers,
        adverse_event: AdverseEvent,
        websockets: Websockets,
        translations: Translations,
        themes: Themes,
        user: User,
        notifications: Notifications,
        reports: Reports,
        consultants: Consultants,
        notification_consultant: NotificationConsultant,
        patients: Patients,
        notification_patient: NotificationPatient,
        pharmacy_groups: PharmacyGroups,
        notification_pharmacy_group: NotificationPharmacyGroup,
        pharmacy_sites: PharmacySites,
        notification_pharmacy_site: NotificationPharmacySite,
        dms_users: DmsUsers,
        dms_roles: DmsRoles,
        laboratories: Laboratories,
        notification_laboratory: NotificationLaboratory,
        astm_devices: ASTMDevices,
        quick_help: QuickHelp,
        data_table: BDataTable,
        qualityControl: QualityControl,
        uploadPdf: UploadPdf,
        spire,
        memo: Memo,
        search: Search,
        secure_sign_forms: SecureSignForms,
    },
});

export default store;
